import { NavLink, useLocation } from 'react-router-dom';
import { BookOpen, Calendar, FlaskConical, ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTotalIncompleteCount, useTotalUnviewedCount } from '../../hooks/useChildrenCounts';

const navItems = [
  { path: '/', icon: BookOpen, labelKey: 'nav.courses' },
  { path: '/research', icon: FlaskConical, labelKey: 'nav.research', showResearchBadge: true },
  { path: '/consulting', icon: ClipboardList, labelKey: 'nav.consulting' },
  { path: '/planner', icon: Calendar, labelKey: 'nav.planner', showPlannerBadge: true },
];

export default function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const { totalCount: incompleteCount } = useTotalIncompleteCount();
  const { totalCount: unviewedCount } = useTotalUnviewedCount();

  // Don't show on login page
  if (location.pathname === '/login') {
    return null;
  }

  return (
    <nav className="bottom-nav sm:hidden">
      <div className="flex items-start py-2">
        {/* eslint-disable-next-line no-unused-vars */}
        {navItems.map(({ path, icon: Icon, labelKey, showPlannerBadge, showResearchBadge }) => {
          const isActive = path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(path);
          const showPlannerNotification = showPlannerBadge && unviewedCount > 0;
          const showResearchNotification = showResearchBadge && incompleteCount > 0;

          return (
            <NavLink
              key={path}
              to={path}
              className={`bottom-nav-item relative flex-1 ${isActive ? 'active' : ''}`}
            >
              {/* Icon with badge positioned relative to icon */}
              <div className="relative">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
                {showPlannerNotification && (
                  <span className="absolute -top-1.5 -right-5 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center badge-animate">
                    {unviewedCount > 9 ? '9+' : unviewedCount}
                  </span>
                )}
                {showResearchNotification && (
                  <span className="absolute -top-1.5 -right-5 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center badge-animate">
                    {incompleteCount > 9 ? '9+' : incompleteCount}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium leading-tight text-center whitespace-pre-line transition-all duration-200">
                {t(labelKey)}
              </span>
              {isActive && (
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 bg-[#589DD5] rounded-full" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
